
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import { UsCtV1 } from '@iabtcf/gpp/encoder/section/UsCtV1.js'; 
import { updateCMPConnecticut } from './updateCMPFuncs.js'

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})



export default class LayerStateConnecticut extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsCtV1.NAME
  sectionID = UsCtV1.ID
  dirty = false

	mounted(): void {
    console.log("Connecticut Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
          this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
          this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'TargetedAdvertisingOptOut') == 2  ? true : false;
        }
      else  {
        updateCMPConnecticut( true, this.cmpApi, this.consentToSharing )
      }
	}

  sensitiveDataChange( consentArray: any ) {
    console.log("LayerStateConnecticut: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  } 

  @Emit('changeViewEvent')
	saveSettingsClick( consentToAll : Boolean ): string {
    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }

    updateCMPConnecticut( consentToAll, this.cmpApi, this.consentToSharing )
    this.cmpApi.fireEvent( "sectionChanged", this.consentToAll);
    return 'close'
	}
  
}
